import { put, cancelled, select, call } from 'redux-saga/effects';
import { createAsyncAction, createReducer } from 'typesafe-actions';
import { api } from 'api';
import { getArticle, getEnv, getRegion } from 'common/selectors';
import log from 'loglevel';
import { EffectR } from 'types/utils';
import { ProductMedia } from '../types';
import { fetchProductMedia } from './api';
import { RESET } from './product-main-info';

export const FETCH_PRODUCT_MEDIA = createAsyncAction(
  'product/FETCH_PRODUCT_MEDIA/request',
  'product/FETCH_PRODUCT_MEDIA/success',
  'product/FETCH_PRODUCT_MEDIA/failure',
  'product/FETCH_PRODUCT_MEDIA/cancel',
)<void, ProductMedia, Response | Error, void>();

export const mediaError = createReducer<Response | Error | null>(null)
  .handleAction([FETCH_PRODUCT_MEDIA.failure], (_, { payload }) => payload)
  .handleAction([FETCH_PRODUCT_MEDIA.request, FETCH_PRODUCT_MEDIA.success, RESET], () => null);

export const mediaLoading = createReducer(false)
  .handleAction([FETCH_PRODUCT_MEDIA.request], () => true)
  .handleAction(
    [FETCH_PRODUCT_MEDIA.success, FETCH_PRODUCT_MEDIA.failure, FETCH_PRODUCT_MEDIA.cancel, RESET],
    () => false,
  );

export const productMedia = createReducer<ProductMedia | null>(null)
  .handleAction(
    [
      // FETCH_PRODUCT_MEDIA.request,
      FETCH_PRODUCT_MEDIA.failure,
      FETCH_PRODUCT_MEDIA.cancel,
      RESET,
    ],
    () => null,
  )
  .handleAction(FETCH_PRODUCT_MEDIA.success, (_, { payload }) => payload);

export function* doFetchProductMedia() {
  const productId: string = yield select(getArticle);
  const regionCode: string = yield select(getRegion);

  const abortController = (yield call([api, 'abortController'])) as EffectR.Call<
    (typeof api)['abortController']
  >;

  yield put(FETCH_PRODUCT_MEDIA.request());
  const { requestID } = (yield select(getEnv)) as EffectR.Select<typeof getEnv>;
  yield call(log.info, 'Product-media was requested', 'requestID: ', requestID, 'dateNow: ', Date.now());

  try {
    const data = (yield call(
      fetchProductMedia,
      { productId, regionCode },
      abortController.token,
    )) as EffectR.Call<typeof fetchProductMedia>;

    yield put(FETCH_PRODUCT_MEDIA.success(data));
    yield call(log.info, 'Product-media was loaded', 'requestID: ', requestID, 'dateNow: ', Date.now());
  } catch (e) {
    if (e instanceof Error) {
      yield put(FETCH_PRODUCT_MEDIA.failure(e));
      yield call(
        log.info,
        'Product-media has error',
        'requestID: ',
        requestID,
        'dateNow: ',
        Date.now(),
        'e',
        e,
      );
    }
  } finally {
    if ((yield cancelled()) as boolean) {
      abortController.cancel();
      yield call(log.info, 'Product-media was cancelled', 'requestID: ', requestID, 'dateNow: ', Date.now());
      yield put(FETCH_PRODUCT_MEDIA.cancel());
    }
  }
}
